import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppButton } from "@/components/layout/WhatsAppButton";
import { HeroSection } from "@/components/sections/HeroSection";
import { AboutSection } from "@/components/sections/AboutSection";
import { ServicesSection } from "@/components/sections/ServicesSection";
import { CatalogSection } from "@/components/sections/CatalogSection";
import { ContactSection } from "@/components/sections/ContactSection";

export default function App() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div
      className="min-h-screen bg-white text-[#0A2540] w-full overflow-x-hidden"
      style={{ fontFamily: "Montserrat, sans-serif" }}
    >
      <Header onNavigate={scrollToSection} />

      <main>
        <HeroSection onNavigate={scrollToSection} />
        <AboutSection />
        <ServicesSection />
        <CatalogSection />
        <ContactSection />
      </main>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}